<template>

<app-input :label="label" :no-line="true" :notes="notes" :disabled="disabled" :validation="validation">

	<div class="toggle" :class="{'is-slim': slim, 'is-fullwidth': fullWidth, 'is-stacked': stacked}">
		<div class="toggle-item" v-for="option in finalOptions" :key="option.value" :class="{'is-active': isSelected(option.value), 'is-divide': !option.value}" v-on:click="onClick(option.value)">
			<app-icon :icon="option.icon" class="toggle-item-icon" />
            {{ option.text }}
			<app-icon icon="tick" class="toggle-item-tick" v-if="isSelected(option.value)" />
		</div>
	</div>

</app-input>

</template>

<script>

export default {

	props: ['validation', 'label', 'value', 'stacked', 'notes', 'fullWidth', 'slim', 'placeholder', 'options', 'disabled'],

	computed: {

		finalOptions: function() {
			
			return (this.options) ? this.options : []

		}

	},

	methods: {

		onClick: function(value) {

			var original = this.$_.clone(this.value)

			if (this.$_.contains(original, parseInt(value))) {

				original.splice(original.indexOf(parseInt(value)), 1)

			} else {

				original.push(parseInt(value))

			}

			this.$emit('input', original)

		},

		isSelected: function(value) {

            if(!value) return false

			return this.$_.contains(this.value, parseInt(value))

		}

	}

}

</script>

<style scoped>

.toggle {
	display: flex;
	flex-direction: row;
	height: 40px;
	border-radius: 12px;
}

.toggle.is-stacked,
.is-mobile .toggle {
	flex-direction: column;
	height: auto;
}

.toggle-item {
	font-size: 16px;
	color: #eee;
	border: 4px solid #eee;
	border-width: 2px 2px 2px 0px;
	color: #333;
	min-width: 60px;
	padding: 0px 10px;
    user-select: none;
	cursor: pointer;
	text-align: center;
	background-color: #fff;
	line-height: 36px;
    display: grid;
    grid-template-columns: 40px auto;
}

.toggle-item:hover {
    background-color: #f7f7f7;
}

.toggle.is-fullwidth .toggle-item {
	flex-grow: 1;
	flex-shrink: 0;
}

.toggle.is-stacked .toggle-item {
	text-align: left;
}

.toggle.is-stacked .toggle-item,
.is-mobile .toggle-item {
	border-width: 2px 2px 0px 2px;
}

.toggle.is-stacked .toggle-item,
.is-device .toggle-item {
	font-size: 14px;
}

.toggle.is-slim .toggle-item {
	width: auto;
	padding: 0px 20px;
}

.toggle-item.is-active {
	background-color: #4082d3;
	color: #fff;
	border-color: #4083d3;
}

.toggle-item:first-child {
	border-left-width: 2px;
	border-radius: 12px 0px 0px 12px;
}

.toggle.is-stacked .toggle-item:first-child,
.is-mobile .toggle-item:first-child {
	border-radius: 12px 12px 0px 0px;
}

.toggle-item:last-child {
	border-radius: 0px 12px 12px 0px;
	border-bottom-width: 2px;
}

.toggle.is-stacked .toggle-item:last-child,
.is-mobile .toggle-item:last-child {
	border-radius: 0px 0px 12px 12px;
	border-bottom-width: 2px;
}

.toggle-item:first-child:last-child {
	border-radius: 12px;
}

.toggle-item-icon {
    text-align: center;
    padding-right: 10px;
}

.toggle-item-tick {
	position: absolute;
	right: 10px;
	top: 2px;
}

</style>
